// shouldFetchSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const shouldFetchSlice = createSlice({
  name: 'shouldFetch',
  initialState: {
    value: false,
  },
  reducers: {
    setShouldFetch: (state, action: PayloadAction<boolean>) => {
      state.value = action.payload;
    },
  },
});

export const { setShouldFetch } = shouldFetchSlice.actions;

export default shouldFetchSlice.reducer;
